import React from 'react';
import { Heart } from 'lucide-react';
import AnimatedSection from './AnimatedSection';

const Footer = () => {
  const currentYear = new Date().getFullYear();
  
  return (
    <footer className="py-12 px-4 border-t border-[#2a2a2a] relative mt-20">
      <AnimatedSection animation="fade-up">
        <div className="max-w-7xl mx-auto">
          <div className="flex flex-col md:flex-row items-center justify-between gap-4">
            <div className="flex items-center gap-2 text-[#a0a0a0] text-sm">
              <span>© {currentYear} Pierre Iaccarino.</span>
              <span>Tous droits réservés.</span>
            </div>
            
            <div className="flex items-center gap-2 text-[#a0a0a0] text-sm">
              <span>Fait avec</span>
              <Heart className="w-4 h-4 text-[#FF4D8D] fill-[#FF4D8D] animate-pulse" />
            </div>
          </div>
        </div>
      </AnimatedSection>
    </footer>
  );
};

export default Footer;